import React from 'react';
import { Box, Typography, Stepper, Step, StepLabel } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Footer from './Footer';

const PageLayout = ({ children, activeStep, subheading }) => {
    const theme = useTheme();
    const steps = ['', '', '', '', ''];

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Typography variant="h1" sx={theme.intro.title}>
                The WhyLine™: 5 Whys Strategy Framework
            </Typography>
            
            {activeStep >= -1 && (
                <>
                   <Stepper 
    activeStep={activeStep > -1 ? activeStep : -1}
    sx={{
        overflowX: 'auto',
        '& .MuiStep-root': {
            minWidth: 'fit-content',
            px: { xs: 1, sm: 2 }
        }
    }}
>
                        {steps.map((_, index) => (
                            <Step key={index}>
                                <StepLabel />
                            </Step>
                        ))}
                    </Stepper>
                    
                    {subheading && (
                        <Typography variant="h2" sx={theme.intro.subheading}>
                            {subheading}
                        </Typography>
                    )}
                </>
            )}
            
            <Box sx={{ flex: 1 }}>
                {children}
            </Box>
            
            <Footer />
        </Box>
    );
};

export default PageLayout;